import store from '../store'
import Cookies from 'js-cookie'
import constantValue from '@/constantValue'
import { MaintenanceCheck } from '@/api'

export const authorizeToken = async (to, from, next) => {
  // メンテナンスモードチェック
  if (to.path === '/maintenance' || to.path === '/error') {
    next()
    return
  }
  await MaintenanceCheck.maintenanceCheck()

  // 認証が必要な画面かどうか取得
  const requiresAuth = to.meta.requiresAuth
  const requiresAdminAuth = to.meta.requiresAdminAuth
  const requiresGroupAdminAuth = to.meta.requiresGroupAdminAuth

  // ルートのメタフィールドに`requiresAuth`が付与されているか判定 認証不要のページはそのまま遷移させる
  if (!requiresAuth) {
    next()
    return
  }

  // 外部連携先からの仮パスワード変更リクエスト
  if (to.path === '/change-password') {
    const token = Cookies.get(constantValue.cookieKeyForAuthToken) || ''
    if (token !== '') {
      store.dispatch('setAuthToken', { token: token })
      Cookies.remove(constantValue.cookieKeyForAuthToken)
    }
  }
  // トークンが無ければ
  if (!store.state.auth || !store.state.auth.token) {
    next({ path: '/login' })
    return
  }

  // API KICK時のTokenチェックと重複するが、リロード時のstate取得のため必要
  await store.dispatch('checkAuthToken') // 認証トークンをサーバで検証
    .catch(() => {
      next({ path: '/login' })
    })

  if (store.state.auth.tempPasswordAuthFlg === '1') { // 仮パスワード認証状態
    if (to.path !== '/change-password') {
      next({ path: '/login' })
      return
    }
  }

  // 権限がない場合はサービス一覧に遷移
  if (roleGuard(requiresAdminAuth, requiresGroupAdminAuth)) {
    next({ path: '/' })
    return
  }
  next()
}

const roleGuard = (requiresAdminAuth, requiresGroupAdminAuth) => {
  if (!requiresAdminAuth && !requiresGroupAdminAuth) {
    return false
  }
  // 管理者用画面は管理者でないと開くことは出来ない
  if (requiresAdminAuth && !store.getters.isAdminFlg) {
    return true
  }
  // グループ管理者用画面は、管理者・グループ管理者でないと開くことは出来ない
  if (requiresGroupAdminAuth && !store.getters.isAdminFlg && !store.getters.isGroupAdminFlg) {
    return true
  }
}
